import React from 'react';
import {Loader, type StrictLoaderProps} from 'semantic-ui-react';

export interface WandbLoaderProps extends StrictLoaderProps {
  className?: string;
  inline?: StrictLoaderProps['inline'];
  name?: string;
  size?: StrictLoaderProps['size'];
}

/**
 * @deprecated use the new wave loader instead
 */
const WandbLoader: React.FC<WandbLoaderProps> = React.memo(
  ({className, inline, size = 'huge'}) => {
    return <Loader active inline={inline} size={size} className={className} />;
  }
);

export default WandbLoader;
